<template>
  <div class="vid-int-end">
    <img src="/static/images/elements/icon_ok.svg"/>
    <div class="vid-int-end-title">
      <div>Вы успешно записали ваше видеообращение.</div>
      <div>{{ $tr('vacancy.preferences.application.sentApplication') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sportmaster-interview-end'
}
</script>

<style scoped lang="scss">
.vid-int-end {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}


.vid-int-end-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    text-align: center;
    color: #233346;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
}
</style>
